import { selectBanners } from '../store/selectors/advertising';

import { useAppSelector } from './redux';

export const useBanners = () => useAppSelector(selectBanners);
